import { ActionUndo } from 'common/components/monochrome-icons';
import { IconButton, Loader } from 'fronton-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { removeButton, removeButtonIcon, inProcessSpinView } from './remove-button.styles';

type RemoveButtonProps = {
  showInProcessSpinner?: boolean;
} & React.HTMLAttributes<HTMLElement>;

export const RemoveButton: React.FC<RemoveButtonProps> = ({ showInProcessSpinner = false, onClick }) => {
  const { t } = useTranslation();
  return (
    <div className={removeButton}>
      <IconButton
        data-qa="file-upload-remove-button"
        onClick={onClick}
        variant="secondary"
        size="l"
        aria-label={t('ui.buttons.remove-image')}
      >
        <ActionUndo className={removeButtonIcon} />
      </IconButton>

      {showInProcessSpinner && <Loader className={inProcessSpinView} size="m" variant="primary" />}
    </div>
  );
};
